import { Component, HostBinding, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'qe-breadcrumbs',
	templateUrl: './breadcrumbs.component.html',
	styleUrls: ['./breadcrumbs.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbsComponent {
	@HostBinding(`class.breadcrumbs`) readonly klassName: boolean = true;

	constructor() { }
}
